import Link from 'next/link';
import styled, { css } from 'styled-components';
import { Typography } from '../../../ui/Typography';
import { Breakpoints } from '../../../../styled/constants';
import { tagStyles } from '../../../ui/Typography/styles';

export const BreadcrumbsSection = styled.div`
  width: 100%;
  height: 37px;
  overflow: hidden;
  padding: 10px 15px;
  background-color: ${({ theme }) => theme.colors.background.primary};

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
    padding: 10px 40px;
  }

  @media screen and (min-width: ${Breakpoints.desktop}px) {
    height: 50px;
    padding: 16px 20px;
  }
`;

export const BreadcrumbsList = styled.ul`
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const breadcrumbsDividerStyles = css`
  content: '•';
  color: ${({ theme: { colors } }) => colors.text.primary};
  position: absolute;
  top: 1px;
  right: -10px;
  width: 3px;
  height: 3px;
`;

export const BreadcrumbLink = styled(Link).attrs({
  prefetch: false,
  locale: false
})`
  color: ${({ theme: { colors } }) => colors.text.primary};
  text-decoration: none;
  font-size: 14px;

  @media screen and (min-width: ${Breakpoints.desktop}px) {
    ${tagStyles.body_1}
  }

  &::after {
    ${breadcrumbsDividerStyles};
  }
`;

export const BreadcrumbText = styled(Typography)`
  &::after {
    ${breadcrumbsDividerStyles};
  }

  @media screen and (min-width: ${Breakpoints.desktop}px) {
    ${tagStyles.body_1}
  }
`;

export const BreadcrumbsItem = styled.li`
  position: relative;
  display: inline-block;
  margin-right: 23px;

  &:last-child {
    margin-right: 0;
  }

  &:last-child {
    ${BreadcrumbLink}::after,
    ${BreadcrumbText}::after {
      display: none;
    }
  }

  a:hover {
    color: ${({ theme }) => theme.colors.systemColors.blue};
  }
`;
